import React, { useState } from 'react';
import { FaCommentDots, FaPaperPlane, FaCheckCircle, FaTimesCircle, FaStar, FaRegStar } from 'react-icons/fa';
import { API_BASE } from '../config';
import './ContactPage.css';
import './FeedbackPage.css';

const feedbackTypes = [
  { value: 'oneri', label: 'Öneri', emoji: '💡' },
  { value: 'memnuniyet', label: 'Memnuniyet', emoji: '😊' },
  { value: 'sikayet', label: 'Şikayet', emoji: '😞' },
  { value: 'diger', label: 'Diğer', emoji: '💬' },
];

const FeedbackPage = () => {
  const [formData, setFormData] = useState({
    type: '', name: '', phone: '', email: '', businessName: '', rating: 0, message: '',
  });
  const [modal, setModal] = useState({ open: false, type: '', message: '' });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.type || !formData.name || !formData.message) {
      setModal({ open: true, type: 'error', message: 'Lütfen görüş türü, adınız ve mesajınızı doldurun.' });
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API_BASE}/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!res.ok) throw new Error();
      setModal({ open: true, type: 'success', message: 'Görüşünüz başarıyla iletildi. Değerli geri bildiriminiz için teşekkür ederiz.' });
      setFormData({ type: '', name: '', phone: '', email: '', businessName: '', rating: 0, message: '' });
    } catch {
      setModal({ open: true, type: 'error', message: 'Gönderilirken hata oluştu. Lütfen tekrar deneyin.' });
    }
    setSending(false);
  };

  return (
    <div className="contact-page">
      {modal.open && (
        <div className="contact-modal-overlay" onClick={() => setModal({ ...modal, open: false })}>
          <div className="contact-modal" onClick={e => e.stopPropagation()}>
            <div className={`contact-modal-icon ${modal.type}`}>
              {modal.type === 'success' ? <FaCheckCircle /> : <FaTimesCircle />}
            </div>
            <h3 className="contact-modal-title">{modal.type === 'success' ? 'Teşekkürler!' : 'Hata'}</h3>
            <p className="contact-modal-message">{modal.message}</p>
            <button className="contact-modal-btn" onClick={() => setModal({ ...modal, open: false })}>Tamam</button>
          </div>
        </div>
      )}

      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <span className="contact-hero-badge"><FaCommentDots style={{ marginRight: 6 }} /> GERİ BİLDİRİM</span>
          <h1 className="contact-hero-title">Görüş Bildir</h1>
          <p className="contact-hero-desc">
            Her türlü öneri, memnuniyet ve şikayet taleplerinizi bizimle paylaşın. Görüşleriniz bizim için çok değerli.
          </p>
        </div>
      </section>

      <section className="contact-main">
        <div className="contact-form-container">
          <div className="contact-form-wrapper">
            <h2 className="contact-form-title">Görüşünüzü Paylaşın</h2>
            <p className="contact-form-desc">Aşağıdaki formu doldurarak bize görüşlerinizi iletebilirsiniz.</p>

            <form className="contact-form" onSubmit={handleSubmit}>
              {/* Feedback Type Selection */}
              <div className="contact-field">
                <label>Görüş Türü *</label>
                <div className="fb-type-grid">
                  {feedbackTypes.map(t => (
                    <button
                      key={t.value}
                      type="button"
                      className={`fb-type-btn ${formData.type === t.value ? 'active' : ''}`}
                      onClick={() => setFormData({ ...formData, type: t.value })}
                    >
                      <span className="fb-type-emoji">{t.emoji}</span>
                      <span>{t.label}</span>
                    </button>
                  ))}
                </div>
              </div>

              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Adınız Soyadınız *</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Ad Soyad" />
                </div>
                <div className="contact-field">
                  <label>İşletme Adı</label>
                  <input type="text" name="businessName" value={formData.businessName} onChange={handleChange} placeholder="Hangi işletme hakkında? (Opsiyonel)" />
                </div>
              </div>

              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Telefon</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="05XX XXX XX XX" />
                </div>
                <div className="contact-field">
                  <label>E-posta</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="ornek@email.com" />
                </div>
              </div>

              {/* Star Rating */}
              <div className="contact-field">
                <label>Genel Değerlendirme</label>
                <div className="fb-stars">
                  {[1, 2, 3, 4, 5].map(star => (
                    <button
                      key={star}
                      type="button"
                      className="fb-star-btn"
                      onClick={() => setFormData({ ...formData, rating: star })}
                    >
                      {star <= formData.rating ? <FaStar /> : <FaRegStar />}
                    </button>
                  ))}
                  {formData.rating > 0 && (
                    <span className="fb-star-label">
                      {['', 'Çok Kötü', 'Kötü', 'Orta', 'İyi', 'Mükemmel'][formData.rating]}
                    </span>
                  )}
                </div>
              </div>

              <div className="contact-field">
                <label>Mesajınız *</label>
                <textarea name="message" value={formData.message} onChange={handleChange} rows={5} placeholder="Görüşünüzü detaylı olarak yazın..." />
              </div>

              <button type="submit" className="contact-submit-btn" disabled={sending}>
                {sending ? 'Gönderiliyor...' : <><FaPaperPlane /> Görüşü Gönder</>}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FeedbackPage;
